import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ShopService } from '../../../shop/services/shop.service';
import { ShopCartsComponent } from "../../../shop/components/shop-carts/shop-carts.component";
import { NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { AuthService } from '../../../auth/services/auth.service';
import { AutocompleteComponent } from "../autocomplete/autocomplete.component";
import { firstValueFrom } from 'rxjs';
import { InitialsPipe } from '../../pipes/initials.pipe';
import { ModalService } from '../../services/modal.service';
import { ModalComponent } from "../modal/modal.component";

@Component({
  selector: 'app-header',
  imports: [RouterLink, RouterLinkActive, ShopCartsComponent, NgbDatepickerModule, ReactiveFormsModule, 
            JsonPipe, AutocompleteComponent, InitialsPipe, ModalComponent, FormsModule],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {

  authService = inject(AuthService);
  shopService = inject(ShopService);
  modalService = inject(ModalService);

  curAppSubscriptionId: string = this.authService.appSubscription().id;

  openSubscriptionsModal() {
    this.modalService.open('subscriptionsModal');
  }

  closeModal() {
    this.modalService.close('subscriptionsModal');
  }

  changeSubscription() {

    this.authService.changeSessionSubscription(this.curAppSubscriptionId).subscribe(() => {
      location.reload();
    });
  }
}
